import { SeriesItemsIndexesRange } from '../model/time-data';
import { LinePoint, LineType } from './draw-line';
import { VectorCatcher } from '../model/vector-catcher';
import { LineItem } from './line-renderer';

/**
 * BEWARE: The method must be called after beginPath and before stroke/fill/closePath/etc
 */
export function walkLine(
	ctx: CanvasRenderingContext2D,
	points: ReadonlyArray<LinePoint>,
	datas: ReadonlyArray<LineItem>,
	lineType: LineType,
	visibleRange: SeriesItemsIndexesRange
): void {
	if (points.length === 0) {
		return;
	}

	//TimedValue & PricedValue & LinePoint;

	const x = points[visibleRange.from].x as number;
	const y = points[visibleRange.from].y as number;
	ctx.moveTo(x, y);

	for (let i = visibleRange.from + 1; i < visibleRange.to; ++i) {
		const currItem = points[i];

		//  x---x---x   or   x---x   o   or   start
		if (lineType === LineType.WithSteps) {
			const prevY = points[i - 1].y;
			const currX = currItem.x;
			ctx.lineTo(currX, prevY);
		}

		ctx.lineTo(currItem.x, currItem.y);
	}

	if (VectorCatcher.catching())
	{
		//if (Pane.getActivePaneID()==1)
		{
		VectorCatcher.setContext(ctx);
		}


		VectorCatcher.startContLine();
		VectorCatcher.addPoint(x,y,datas[visibleRange.from]);

		for (let i = visibleRange.from + 1; i < visibleRange.to; ++i) {
			const currItem = points[i];
	
			//  x---x---x   or   x---x   o   or   start
			if (lineType === LineType.WithSteps) {
				const prevY = points[i - 1].y;
				const currX = currItem.x;
				//ctx.lineTo(currX, prevY);
				VectorCatcher.addPoint(currX, prevY,datas[i]);
			}
				
			//ctx.lineTo(currItem.x, currItem.y);
			VectorCatcher.addPoint(currItem.x, currItem.y,datas[i]);
		}
	
		VectorCatcher.endContLine();
	}
}
